import Api, { baseURL, requestOptionsGET, requestOptionsPOSTwithFormData, requestOptionsPUTWithBody } from '../api';
import newFetch from '../utils/newFetch';

const state = {
  stops: [],
  manegementStops: [],
  deliveries: [],
  manegementDeliveries: [],
  nfes: [],
  transhipmentDeliverersSummary: [],
  manegementNfes: [],
  callNumber: '',
  paginate: {
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  },
  filters: {
    JustificationId: null,
    TranshipmentId: null,
    DirectDelivererId: null,
    TranshipmentDelivererId: null,
    StateId: null,
    CityId: null,
    SenderId: null,
    CteNumber: null,
    NfeNumber: null,
    StatusId: null
  }
};

const getters = {
  getStops: (state) => state.stops,
  getManegementStops: (state) => state.manegementStops,
  getDeliveries: (state) => state.deliveries,
  getManegementDeliveries: (state) => state.manegementDeliveries,
  getFilters: ({ paginate, filters }) => {
    return (
      `&PageSize=${paginate.pageSize}&PageNumber=${paginate.pageNumber}` +
      (filters.JustificationId ? `&JustificationId=${filters.JustificationId}` : '') +
      (filters.TranshipmentId ? `&TranshipmentId=${filters.TranshipmentId}` : '') +
      (filters.DirectDelivererId ? `&DirectDelivererId=${filters.DirectDelivererId}` : '') +
      (filters.SenderId ? `&SenderId=${filters.SenderId}` : '') +
      (filters.TranshipmentDelivererId ? `&TranshipmentDelivererId=${filters.TranshipmentDelivererId}` : '') +
      (filters.StateId ? `&StateId=${filters.StateId}` : '') +
      (filters.CityId ? `&CityId=${filters.CityId}` : '') +
      (filters.CteNumber && filters.CteNumber.length > 0
        ? filters.CteNumber.map((element) => `&CteNumber=${element}`).join('')
        : '') +
      (filters.NfeNumber && filters.NfeNumber.length > 0
        ? filters.NfeNumber.map((element) => `&NfeNumber=${element}`).join('')
        : '')
    );
  }
};

const mutations = {
  setStops(state, payload) {
    state.stops = payload;
  },
  setManegementStops(state, payload) {
    state.manegementStops = payload;
  },
  setDeliveries(state, payload) {
    state.deliveries = payload;
  },
  setManegementDeliveries(state, payload) {
    state.manegementDeliveries = payload;
  },
  setNfes(state, payload) {
    state.nfes = payload;
  },
  setTranshipmentDeliverersSummary(state, payload) {
    state.transhipmentDeliverersSummary = payload;
  },
  setManegementNfes(state, payload) {
    state.manegementNfes = payload;
  },
  setItemPerPage(state, payload) {
    state.paginate.pageSize = payload;
  },
  setPageNumber(state, payload) {
    state.paginate.pageNumber = payload;
  },
  setTotalPages(state, payload) {
    state.paginate.totalPages = payload;
  },
  setTotalRecords(state, payload) {
    state.paginate.totalRecords = payload;
  },
  setFilterJustificationId(state, payload) {
    state.filters.JustificationId = payload;
  },
  setFilterTranshipmentId(state, payload) {
    state.filters.TranshipmentId = payload;
  },
  setFilterDirectDelivererId(state, payload) {
    state.filters.DirectDelivererId = payload;
  },
  setFilterTranshipmentDelivererId(state, payload) {
    state.filters.TranshipmentDelivererId = payload;
  },
  setFilterStateId(state, payload) {
    state.filters.StateId = payload;
  },
  setFilterCityId(state, payload) {
    state.filters.CityId = payload;
  },
  setFilterSenderId(state, payload) {
    state.filters.SenderId = payload;
  },
  setFilterCteNumber(state, payload) {
    state.filters.CteNumber = payload;
  },
  setFilterNfeNumber(state, payload) {
    state.filters.NfeNumber = payload;
  },
  setFilterStatusId(state, payload) {
    state.filters.StatusId = payload;
  },
  setCallNumber(state, payload) {
    state.callNumber = payload;
  },
  setNfeByStatus(state, payload) {
    state.nfeByStatus = payload;
  }
};

const actions = {
  fetchStopsByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getStopByStatus + '?statusId=' + id + context.getters.getFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setStops', data);

          context.commit('setTotalPages', totalPages);
          context.commit('setTotalRecords', totalRecords);

          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  fetchDeliveriesByID(context, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getDeliveriesDetails + model.id + '?statusId=' + model.status + context.getters.getFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          context.commit('setDeliveries', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  fetchNfesByID(context, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getNfe + model.id + '?statusId=' + model.status + context.getters.getFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          context.commit('setNfes', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getNfesByStopAndStatusesIds(context, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getNfesByStopAndStatusesIds +
          `?stopId=${model.stopId}&StatusId=${model.status}` +
          context.getters.getFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  setQuarantineNumber(context, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.updateCallNumberQuarantine + '?nfeId=' + model.id + '&number=' + model.number,
        requestOptionsPOSTwithFormData(localStorage.getItem('accessToken'), model)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getManageTranshipmentDeliverersSummary(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getManageTranshipmentDeliverersSummary + '?transhipmentId=' + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          context.commit('setTranshipmentDeliverersSummary', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getQuarantineNumber(context, id) {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('accessToken')
      }
    };
    const teste = fetch(baseURL + 'pt/api/Nfes/GetQuarantineCallNumber/?nfeId=' + id, options)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        return data;
      })
      .catch((e) => {
        console.error(e);
      });
    return teste;
  },
  moveDeliveryQuarantine(context, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.moveDeliveryQuarantine,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), model)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  moveTransferQuarantine(context, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.moveTransferQuarantine,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), model)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  updateDeliveryForecastDate(context, model) {
    const { deliverieId, deliveryForecast } = model;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + `${Api.updateDeliveryForecastDate}?deliverieId=${deliverieId}&deliveryForecast=${deliveryForecast}`,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), model)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
